import React, { useEffect, useMemo, useState } from "react";
import { Card, CardBody, ListGroup, ListGroupItem } from "reactstrap";
// import { EditIcon } from "./";
// import { PrintIcon } from "./constant";

import { PrintIcon } from "views/pages/manage/masters/studentFinancials/paymentCollection/manage-receipts/viewReceipt/constant";
import {ReactComponent as CopyIcon} from "../../../../assets/img/svg/fi_link.svg"


import { useGetPermissions } from "layouts/customHook";
import { Tooltip } from "@mui/material";
import { useNavigateToGivenPath } from "../../../../views/pages/manage/edpOps/studentDetails/paymentSummary/service";

const ViewActions = ({
  steps=[],
  details,
  refundFlow
}) => {

    const navigateToGivenPath = useNavigateToGivenPath();

    const [tooltipText, setTooltipText] = useState("Copy");
    const [timeoutID, setTimeoutID] = useState(null);
  
    const resetTooltip = () => setTimeout(() => {
      setTooltipText("Copy")
    }, 5000)
  
    useEffect(() => {
      return () => {
        clearTimeout(timeoutID);
      }
    }, [timeoutID])
   const actionDisable=!(Array.isArray(steps)&& steps?.[steps.length-1]?.title=="Refund Processed"&&steps?.[steps.length-1]?.status=='completed')

  const noActionEnableColor = actionDisable
    ? "#B7B7B7"
    : "#0F0F0F";


  //   const [isGeneratingReceipt, setIsGeneratingReceipt] = useState(false);


  //   const printReceiptHandler = async () => {
  //     const { businessArea, receiptId } = studentBasicDetails;

  //     const data = { receipts: [{ businessArea, receiptId }] };
  //     setLoader(true);
  //     await printReceipt(data);
  //     setLoader(false);
  //   };





  const userPermissions = useGetPermissions("studentTransferApproval");

  return (
    <>
        <Card style={{ width: "inherit%", height: "192px", marginLeft: "24px" }}>
          <CardBody>
            <div className="dark-text label-color">Actions</div>
            { details?.orderType=='COMPLETION_REFUND'&& refundFlow == 'tracker'&&<Tooltip title={tooltipText} theme={'dark'}>
            <div
              className="heading-3-normal label-color py-3 d-flex cursor"
              style={{ gap: "16px" }}
              onClick={() => {
                navigator.clipboard.writeText(details?.websitePayModeLink);
                setTooltipText("Copied");
                setTimeoutID(resetTooltip());
              }}
            //   onClick={!actionDisable?.noActionEnable && printReceiptHandler}
            >

              <CopyIcon  />
              <span>
                Copy refund URL
              </span>
            </div>
          </Tooltip>
}
            <div style={{ borderBottom: " 1px solid #E2E2E2" }}></div>
            <div
              className="heading-3-normal label-color py-3 d-flex cursor"
              style={{ gap: "16px" }}
              // onClick={!actionDisable?.noActionEnable && printReceiptHandler}
              onClick={() => {
                if(!actionDisable){
                  navigateToGivenPath('admin/paymentCollection/manageReceipts');
                }
              }}
            >
              <PrintIcon color={noActionEnableColor} />
              <span style={{ color: `${noActionEnableColor}` }}>
                Print Refund Certificate
              </span>
            </div>

          </CardBody>
        </Card>

    </>
  );
};

export default ViewActions;
